'use strict';

var core = require('org_km_b2s/productDetail');

core.baseFiles.variantQuantityLimit = require('./product/variantQuantityLimit');

module.exports = core;
